module.exports = __webpack_public_path__ + "img/suhi-laptop.fb6f5965.jpg";